import { useUserStore } from '@/store'
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { pinia } from '@/config/pinia'

// Define a guard function that checks if the user has the required role
function checkRole(to: RouteLocationNormalized, requiredRoles: any) {
  const store = useUserStore()
  const user = store.user
  if (to.path === '/hr' && !user?.isRRHH) return false
  else {
    return user && user.roles && requiredRoles.includes(user.roles.name)
  }
}

export const requireAuthAndRole = async (
  to: RouteLocationNormalized,
  from: any,
  next: NavigationGuardNext
) => {
  const userStore = useUserStore(pinia)
  const requiredRoles = to.meta.requiredRoles

  try {
    const isAuthenticated = await userStore.isAuthenticated
    // Routes that always require authentication
    const requiresAuthentication = [
      '/requestApprover',
      '/vacations',
      '/letterRequests',
      '',
    ]
    const ableSubRoutes =
      /^\/requestApprover\/[a-f0-9\-]+$/i.test(to.path) ||
      /^\/letterRequests\/[a-f0-9\-]+$/i.test(to.path)

    if (
      (requiresAuthentication.includes(to.path) || ableSubRoutes) &&
      !isAuthenticated
    ) {
      // Specific auth check for certain routes
      localStorage.setItem('redirect', to.path)
      next('/login')
    } else if (to.meta.auth && !isAuthenticated) {
      // General auth check for routes with meta.auth
      next('/login')
    } else if (requiredRoles && !checkRole(to, requiredRoles)) {
      // Role check if requiredRoles is specified
      console.log('Redirecting to login from guard')
      next('/home')
    } else {
      next()
    }
  } catch (error) {
    console.error('Error checking authentication:', error)
    next('/error') // Redirect to an error page if there's an issue with authentication check
  }
}
